import { inject, Injectable } from "@angular/core";
import {
  doc,
  Firestore, getDoc, updateDoc,
} from "@angular/fire/firestore";
import { ObjectHelper } from "../helpers/object.helper";
import { WebProduct } from "../models/web-product.model";

@Injectable({
  providedIn: 'root',
})
export class WebProductService {

  private firestore = inject(Firestore);

  async get(id: string): Promise<WebProduct|null> {
    const ref = doc(this.firestore, 'web-products', id)
      .withConverter(WebProduct.converter);
    const docSnap = await getDoc(ref);
    if (!docSnap.exists()) {
      return null;
    }
    return docSnap.data();
  }

  /**
   * Update a web product
   * @param id The id of the order to update
   * @param partialWebProduct The fields of the order to update
   * @returns The promise
   */
  public update(id: string, partialWebProduct: Partial<WebProduct>): Promise<void> {
    const ref = doc(this.firestore, 'web-products', id)
      .withConverter(WebProduct.converter);
    return updateDoc(ref, ObjectHelper.anonymize(partialWebProduct));
  }
}
